import { render, staticRenderFns } from "./VesselsByMachineryMakeModel.vue?vue&type=template&id=2c35769a&"
import script from "./VesselsByMachineryMakeModel.vue?vue&type=script&lang=js&"
export * from "./VesselsByMachineryMakeModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports